// src/components/shared/BottomNav.js
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useApp } from '../../lib/AppContext';
import { t } from '../../lib/i18n';


export default function BottomNav() {
  const { lang, isAdmin, user, cartCount, dispatch } = useApp();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const items = [
    { icon: '🏠', key: 'home',    path: '/' },
    { icon: '🔍', key: 'search',  path: '/search' },
    { icon: '🛒', key: 'cart',    path: null, action: () => dispatch({ type: 'CART_TOGGLE' }) },
    { icon: '👤', key: 'account', path: user ? '/account' : '/login' },
    ...(isAdmin ? [{ icon: '⚙️', key: 'admin', path: '/admin' }] : []),
  ];

  const isActive = (item) => {
    if (!item.path) return false;
    if (item.path === '/') return pathname === '/';
    return pathname.startsWith(item.path);
  };

  return (
    <div className="mobile-nav">
      {items.map(item => (
        <button
          key={item.key}
          className={`mobile-nav-btn ${isActive(item) ? 'active' : ''}`}
          onClick={() => item.action ? item.action() : navigate(item.path)}
        >
          <span className="bottomnav-item" style={{ position: 'relative' }}>
            {item.key === 'home'
              ? <img src="/logo.png" alt="CosmiqHerbz" className="bottomnav-logo-img" />
              : <span style={{ fontSize: '1.2rem', lineHeight: 1 }}>{item.icon}</span>
            }
            {item.key === 'cart' && cartCount > 0 && (
              <span style={{
                position: 'absolute', top: -4, right: -6,
                background: '#4cca74', color: '#000',
                borderRadius: '50%', width: 14, height: 14,
                fontSize: '.55rem', fontWeight: 800,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}>
                {cartCount}
              </span>
            )}
          </span>
          <span className="mobile-nav-label">
            {item.key === 'home' ? '' : t(item.key, lang)}
          </span>
          {isActive(item) && <div className="mobile-nav-dot" />}
        </button>
      ))}
    </div>
  );
}